import { render, staticRenderFns } from "./Requesttpo.vue?vue&type=template&id=70356465&scoped=true"
import script from "./Requesttpo.vue?vue&type=script&lang=js"
export * from "./Requesttpo.vue?vue&type=script&lang=js"
import style0 from "./Requesttpo.vue?vue&type=style&index=0&id=70356465&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70356465",
  null
  
)

export default component.exports